// extracted by mini-css-extract-plugin
module.exports = {"form":"SendTicketForm_form__2nk4T","button":"SendTicketForm_button__L4zb_"};